import { Flex, Heading, useColorModeValue } from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { PCRoom } from "../../data/pcs.api";

type Props = {
  pcRoom: PCRoom;
};

const PCRoomCard = ({ pcRoom }: Props) => {
  const navigate = useNavigate();
  const bg = useColorModeValue("gray.50", "gray.700");
  const hoverColour = useColorModeValue("gray.100", "gray.600");

  return (
    <Flex
      border="1px solid rgba(0, 0, 0, 0.1)"
      rounded="md"
      overflow="hidden"
      role="group"
      bg={bg}
      cursor="pointer"
      transition=".1s all"
      _hover={{ bg: hoverColour }}
      onClick={() => navigate(`/pcs/${pcRoom.PlanOnId}`)}
      p={5}
      direction="column"
    >
      <Heading size="sm">{pcRoom.Label}</Heading>
    </Flex>
  );
};

export default PCRoomCard;
